import styled from "styled-components";

export const Text = styled.p`
	visibility: hidden;
	width: 400px;
	background-color: ${(props) => props.theme.colours.primary};
	color: white;
	text-align: left;
	padding: 12px;
	border-radius: 6px;
	position: absolute;
	z-index: 1;
	font-size: 0.8rem;
	white-space: pre-line;
	left: 50%;
	transform: translateX(-50%);
	margin-top: 10px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

export const Container = styled.i`
	position: relative;
	color: ${(props) => props.theme.colours.primary};
	font-size: 1rem;
	margin-left: 6px;
	top: ${(props) => props.right && "3px"};
	display: inline-block;
	float: ${(props) => props.right && "right"};
	&:hover ${Text} {
		visibility: visible;
	}
`;
